import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { PomodoroStatsService } from '../services/PomodoroStatsService';
import { PomodoroStatsData } from '../types';

const QUERY_KEY = 'pomodoro-stats';

// Get Pomodoro statistics
export function usePomodoroStats() {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => PomodoroStatsService.getStats(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

// Add completed Pomodoro
export function useAddCompletedPomodoro() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (): Promise<PomodoroStatsData> => {
      return PomodoroStatsService.addCompletedPomodoro();
    },
    onSuccess: (updatedStats: PomodoroStatsData) => {
      queryClient.setQueryData([QUERY_KEY], updatedStats);
      // Also invalidate today's stats
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY, 'today'] });
    },
    onError: (error) => {
      console.error('Failed to add completed Pomodoro:', error);
    },
  });
}

// Get today's statistics
export function useTodayPomodoroStats() {
  return useQuery({
    queryKey: [QUERY_KEY, 'today'],
    queryFn: () => PomodoroStatsService.getTodayStats(),
    staleTime: 1000 * 60, // 1 minute
  });
} 